<app-activity-status
  *ngFor="let projectActivity of projectActivities; let i = index; trackBy: trackEntityById"
  [projectActivity]="projectActivity"
  [allActivities]="projectActivities"
  [currentIndex]="i">
</app-activity-status>
